import styled from "styled-components";

export const Container = styled.aside`
    padding-top: 30px;
`
